import { useState } from "react";
import { useTranslation } from "react-i18next";
import {useLocation, useNavigate} from "react-router-dom";

// Components
import { AuthActionButton } from "../components/AntCostomComponents/Buttons";
import LogoAndText from "../components/LogoAndText";
import {
    Form,
    LeftContainer,
    RightContainer,
    SideWrapper,
    TextContainer,
} from "../components/SideWrapper/SideWrapper.styles";
import { resetPassword } from "../utils/api-lists/login.api";

const LoginPage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation("common");
  const location = useLocation();
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState(null);
  const [token, setToken] = useState(
          new URLSearchParams(location.search).get("token") || ""
      );


console.log("token"+token)

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (password !== confirmPassword) {
      setError("error_passwords_do_not_match");
      return;
    }
    if (password.length < 8) {
      setError("error_invalid_password_format");
      return;
    }
    try {
      // Call your API to reset the password here
      await resetPassword(token, password);
      setError(null);
      navigate("/login");
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <SideWrapper>
      <LeftContainer>
        <LogoAndText />
      </LeftContainer>
      <RightContainer>
        <h2>{t("reset_your_password")}</h2>
        <TextContainer>
          <h3>{t("create_new_password_hint")}</h3>
        </TextContainer>
        <Form
          onSubmit={handleSubmit}
          style={{ marginTop: "40px", maxWidth: "400px" }}
        >
          <label>{t("new_password")}</label>
          <input
            placeholder={t("enter_new_password")}
            name="password"
            type="text"
             autoComplete="new-password"
            onChange={(e) => setPassword(e.target.value)}
          />

          <label>{t("confirm_new_password")}</label>
          <input
            placeholder={t("reenter_new_password")}
            name="confirmPassword"
            type="password"
            autoComplete="new-password"
            onChange={(e) => setConfirmPassword(e.target.value)}
          />
          {error && <p style={{ color: "red" }}>{t(error)}</p>}
          <AuthActionButton text={t("next")} htmlType="submit" />
        </Form>
        <br />
      </RightContainer>
    </SideWrapper>
  );
};

export default LoginPage;
